module.exports = __webpack_public_path__ + "static/img/footer_logo.1cbb32d8.png";